var R = /* @__PURE__ */ ((E) => (E.DARK_GREY = "DARK_GREY", E.BLUE_GREY = "BLUE_GREY", E.BLUE_GREY_75 = "BLUE_GREY_75", E))(R || {});
export {
  R as MenuColumnTheme
};
